var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "col-6 container-box left" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("apps.settings.message.listrolepermission")) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "items custom-scrollbar" },
          _vm._l(_vm.mapList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "item",
                on: {
                  click: function($event) {
                    return _vm.onClickAdd(item.id)
                  }
                }
              },
              [
                _vm._v("\n          " + _vm._s(item.value) + "\n          "),
                _c("i", { staticClass: "fas fa-angle-right" })
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 container-box right" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("apps.settings.message.listrolepermissionassign")) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "items custom-scrollbar" },
          _vm._l(_vm.assigned, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "item",
                on: {
                  click: function($event) {
                    return _vm.onClickRemove(item.id)
                  }
                }
              },
              [
                _vm._v("\n          " + _vm._s(item.value) + "\n          "),
                _c("i", { staticClass: "fas fa-angle-left" })
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bb25130", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb25130","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSelectRolePermission.vue
// module id = null
// module chunks = 